import { render } from "./DigitalInitiatives.vue?vue&type=template&id=6fe70468"
import script from "./DigitalInitiatives.vue?vue&type=script&lang=js"
export * from "./DigitalInitiatives.vue?vue&type=script&lang=js"
script.render = render

export default script